<ion-header>
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button (click)="goBack()">
        <ion-icon color="dark" class="back-icon" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'ACCOUNTS.trial.lbl.try_free' | translate }}
    </ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="content-div ion-padding ion-margin-bottom">
    <ion-img class="img center" [src]="'./assets/wedding/img/subscription/trial/' + (language ? language : 'en') + '.webp'" *ngIf="language"></ion-img>
    <div>
      <div class="ion-margin">
        <div class="font-18 font-med ion-text-center">
          {{ 'ACCOUNTS.trial.lbl.try_thebigday_free' | translate }}
        </div>
        <div class="font-12 ion-text-center">
          {{ 'ACCOUNTS.trial.msg.intro' | translate }}
        </div>
      </div>
      
      <ion-grid class="ion-no-padding">
        <ion-row class="ion-justify-content-center ion-align-items-center">
          <ion-col class="col ion-justify-content-center ion-align-items-center">
            <ion-card class="card ion-no-margin center" color="light" lines="none">
              <div class="full-height center vertical-center">
                <ion-img class="icon-img center" src="./assets/wedding/icon/menu/guestlist.svg"></ion-img>
                <div class="font-10 ion-text-center">{{ 'MENU.guest_list' | translate }}</div>
              </div>
            </ion-card>
          </ion-col>
          <ion-col class="col ion-justify-content-center ion-align-items-center">
            <ion-card class="card ion-no-margin center" color="light" lines="none">
              <div class="full-height center vertical-center">
                <ion-img class="icon-img icon-img-seating center" src="./assets/wedding/icon/guest/seating-outline.svg"></ion-img>
                <div class="font-10 ion-text-center">{{ 'MODULE.action.guest.seating' | translate }}</div>
              </div>
            </ion-card>
          </ion-col>
          <!-- <ion-col class="col ion-justify-content-center ion-align-items-center">
            <ion-card class="card ion-no-margin center" color="light" lines="none">
              <div class="full-height center vertical-center">
                <ion-img class="icon-img center" src="./assets/wedding/icon/menu/rsvp.svg"></ion-img>
                <div class="font-10 ion-text-center">{{ 'MODULE.list.rsvp' | translate }}</div>
              </div>
            </ion-card>
          </ion-col> -->
          <ion-col class="col ion-justify-content-center ion-align-items-center">
            <ion-card class="card ion-no-margin center" color="light" lines="none">
              <div class="full-height center vertical-center">
                <ion-icon class="icon font-20 center" name="chatbox-ellipses-outline"></ion-icon>
                <div class="font-10 ion-text-center">{{ 'MENU.blast' | translate }}</div>
              </div>
            </ion-card>
          </ion-col>
          <ion-col class="col ion-justify-content-center ion-align-items-center">
            <ion-card class="card ion-no-margin center" color="light" lines="none">
              <div class="full-height center vertical-center">
                <ion-img class="icon-img center" src="./assets/wedding/icon/menu/checkin.svg"></ion-img>
                <div class="font-10 ion-text-center">{{ 'MENU.checkin' | translate }}</div>
              </div>
            </ion-card>
          </ion-col>
          <ion-col class="col ion-justify-content-center ion-align-items-center">
            <ion-card class="card ion-no-margin center" color="light" lines="none">
              <div class="full-height center vertical-center">
                <ion-img class="icon-img center" src="./assets/wedding/icon/menu/gift.svg"></ion-img>
                <div class="font-10 ion-text-center">{{ 'MENU.gift' | translate }}</div>
              </div>
            </ion-card>
          </ion-col>
        </ion-row>
      </ion-grid>
      <!-- <div class="included-div font-14 font-med ion-text-center ion-margin">
        {{ 'ACCOUNTS.trial.lbl.included' | translate }}
      </div> -->
  
      <ion-card class="ion-no-margin ion-margin-vertical ion-padding" color="secondary">
        <ion-grid class="full-width font-12" fixed>
          <ion-row>
            <ion-col size="auto">
              <ng-container *ngIf="true then circleCheckMark"></ng-container>
            </ion-col>
            <ion-col>
              <ion-text [innerHTML]="'ACCOUNTS.trial.msg.full_access' | translate"></ion-text>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="auto">
              <ng-container *ngIf="true then circleCheckMark"></ng-container>
            </ion-col>
            <ion-col>
              <ion-text [innerHTML]="'ACCOUNTS.trial.msg.unlimited' | translate"></ion-text>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="auto">
              <ng-container *ngIf="true then circleCheckMark"></ng-container>
            </ion-col>
            <ion-col>
              <ion-text [innerHTML]="'ACCOUNTS.trial.msg.offline' | translate"></ion-text>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="auto">
              <ng-container *ngIf="true then circleCheckMark"></ng-container>
            </ion-col>
            <ion-col>
              <ion-text [innerHTML]="'ACCOUNTS.trial.msg.platform' | translate"></ion-text>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="auto">
              <ng-container *ngIf="true then circleCheckMark"></ng-container>
            </ion-col>
            <ion-col>
              <div class="point-div"><ion-text [innerHTML]="'ACCOUNTS.trial.msg.sync' | translate"></ion-text></div>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="auto">
              <ng-container *ngIf="true then circleCheckMark"></ng-container>
            </ion-col>
            <ion-col>
              <ion-text [innerHTML]="'ACCOUNTS.trial.msg.max_guest' | translate: { count: getTrialMaxGuest() }"></ion-text>
            </ion-col>
          </ion-row>
          <ion-row>
            <ion-col size="auto">
              <ng-container *ngIf="true then circleCheckMark"></ng-container>
            </ion-col>
            <ion-col>
              <ion-text [innerHTML]="'ACCOUNTS.trial.msg.trial_limit' | translate: { count: getTrialLimit() }"></ion-text>
            </ion-col>
          </ion-row>
        </ion-grid>
      </ion-card>
    </div>
  </div>
</ion-content>

<ion-footer>
  <ion-toolbar>
    <div class="content-div ion-padding">
      <ion-button expand="block" (click)="checkUserLogin()">
        {{ 'BTN.get_it_now'| translate }}
      </ion-button>
      <div class="ion-text-center" (click)="goPremiumPage()">
        <ion-text class="font-10 font-underline">{{ 'ACCOUNTS.trial.lbl.buy_premium' | translate }}</ion-text>
      </div>
    </div>
  </ion-toolbar>
</ion-footer>

<ng-template #circleCheckMark>
  <div class="icon-div"><ion-icon class="icon-small" name="checkmark-circle" color="success"></ion-icon></div>
</ng-template>
